<template>
  <!-- 问诊单通用样式 -->
  <div class="question-paper" v-if="formData">
    <!-- 中医问诊单内容 -->
    <template v-if="formData.type == 1">
      <div class="card">
        <div class="card-header">
          <h3>问诊单</h3>
          <span class="date">复诊时间：{{formData.start_time | dateFilter}}-{{formData.end_time | timeFilter}}</span>
        </div>
        <div class="card-content">
          <div class="baseinfo-item">
            <div class="type">就诊人信息</div>
            <div class="content">
              <div class="patient-info">{{formData.pat_username}}<span>|</span>{{formData.gender | genderFilter}}<span>|</span>{{formData.birthday | ageFilter}}</div>
            </div>
          </div>
          <div class="baseinfo-item">
            <div class="type">最近一次就诊医院</div>
            <div class="content">{{formData.hospital|| '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">最近一次就诊科室</div>
            <div class="content">{{formData.last_depname|| '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">疾病名称</div>
            <div class="content">{{formData.disease|| '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">症状变化</div>
            <div class="content">{{formData.sym_change}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.is_anesis != 3">
            <div class="type">是否得到缓解</div>
            <div class="content">{{formData.is_anesis == 1 ? '是' : '否'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">本次就诊急需改善的症状</div>
            <div class="content">{{formData.improve || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">其他不舒服或希望治疗的症状</div>
            <div class="content">{{formData.symptom || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">既往病史</div>
            <div class="content">{{formData.sickpast || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">传染病史</div>
            <div class="content">{{formData.infectious || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">舌面舌底照片</div>
            <div class="content">
              <div class="question-image-wrapper">
                <div class="question-image" @click="previewImage(formData.tongue_img, 0)"><img :src="formData.tongue_img[0]"></div>
                <div class="question-image" @click="previewImage(formData.tongue_img, 1)"><img :src="formData.tongue_img[1]"></div>
              </div>
            </div>
          </div>
          <div class="baseinfo-item" v-if="formData.face_img && formData.face_img.length > 0">
            <div class="type">面象照片</div>
            <div class="content">
              <div class="question-image-wrapper">
                <div class="question-image" @click="previewImage(formData.face_img, index)" v-for="(item, index) in formData.face_img"><img
                    :src="item"></div>
              </div>
            </div>
          </div>
          <div class="baseinfo-item" v-if="formData.result_img && formData.result_img.length > 0">
            <div class="type">检查结果及报告</div>
            <div class="content">
              <div class="question-image-wrapper">
                <div class="question-image" @click="previewImage(formData.result_img, index)" v-for="(item, index) in formData.result_img"><img
                    :src="item"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card question-card" v-if="formData.second && formData.second.length > 0" v-for="question in formData.second">
        <div class="question-header">{{question.questionsType}}</div>
        <div class="question-list">
          <div class="qa-item" v-for="(item, index) in question.questionList">
            <div class="question">{{index + 1}}. {{item.question}}</div>
            <div class="answer" v-if="item.questionType == 'text'">{{item.text}}</div>
            <div class="answer" v-else-if="item.questionType == 'radio'">{{item.picked[0]}}</div>
            <div class="answer" v-else-if="item.questionType == 'mulitple'">{{item.picked.join('；')}}</div>
          </div>
        </div>
      </div>
      <div class="card question-card" v-if="formData.third && formData.third.length > 0" v-for="question in formData.third">
        <div class="question-header">{{question.questionsType}}</div>
        <div class="question-list">
          <div class="qa-item" v-for="(item, index) in question.questionList">
            <div class="question">{{index + 1}}. {{item.question}}</div>
            <div class="answer" v-if="item.questionType == 'text'">{{item.text}}</div>
            <div class="answer" v-else-if="item.questionType == 'radio'">{{item.picked[0]}}</div>
            <div class="answer" v-else-if="item.questionType == 'mulitple'">{{item.picked.join('；')}}</div>
          </div>
        </div>
      </div>
    </template>
    <!-- 西医问诊单内容 -->
    <template v-else>
      <div class="card">
        <div class="card-header">
          <h3>问诊单</h3>
          <span class="date">复诊时间：{{formData.start_time | dateFilter}}-{{formData.end_time | timeFilter}}</span>
        </div>
        <div class="card-content">
          <div class="baseinfo-item">
            <div class="type">就诊人信息</div>
            <div class="content">
              <div class="patient-info">{{formData.pat_username}}<span>|</span>{{formData.gender | genderFilter}}<span>|</span>{{formData.birthday | ageFilter}}</div>
            </div>
          </div>
          <div class="baseinfo-item">
            <div class="type">症状变化</div>
            <div class="content">{{formData.sym_change}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.relieve != 3">
            <div class="type">是否得到缓解</div>
            <div class="content">{{formData.second.relieve == 1 ? '是' : '否'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.exacerbated">
            <div class="type">诱发或加重的因素</div>
            <div class="content">{{formData.second.exacerbated || '无'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.ease">
            <div class="type">缓解的因素</div>
            <div class="content">{{formData.second.ease || '无'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.uncomfortable">
            <div class="type">其他不舒服或希望治疗的症状</div>
            <div class="content">{{formData.second.uncomfortable || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">现病史</div>
            <div class="content">{{formData.second.sickNow || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">既往病史</div>
            <div class="content">{{formData.second.sickPast || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">过敏史</div>
            <div class="content">{{formData.second.allergy || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">个人史</div>
            <div class="content">{{formData.second.personal || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">婚育史</div>
            <div class="content">{{formData.second.marry || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">家族史</div>
            <div class="content">{{formData.second.family || '无'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.bodyTemperature">
            <div class="type">体温 (℃)</div>
            <div class="content">{{formData.second.bodyTemperature}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.heartRate">
            <div class="type">心率 (次/分)</div>
            <div class="content">{{formData.second.heartRate || '无'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.breath">
            <div class="type">每分钟呼吸数 (次/分)</div>
            <div class="content">{{formData.second.breath || '无'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.bloodPressureExpand || formData.second.bloodPressureShrink">
            <div class="type">血压 (mmHg)</div>
            <div class="content"><span v-if="formData.second.bloodPressureShrink">收缩压:
                {{formData.second.bloodPressureShrink}}</span> <span v-if="formData.second.bloodPressureExpand">舒张压:
                {{formData.second.bloodPressureExpand}}</span></div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.face_img && formData.second.face_img.length > 0">
            <div class="type">面象及病患处照片</div>
            <div class="content">
              <div class="question-image-wrapper">
                <div class="question-image" @click="previewImage(formData.second.face_img, index)" v-for="(item, index) in formData.second.face_img"><img
                    :src="item"></div>
              </div>
            </div>
          </div>
          <div class="baseinfo-item" v-if="formData.second.result_img && formData.second.result_img.length > 0">
            <div class="type">检查结果及报告</div>
            <div class="content">
              <div class="question-image-wrapper">
                <div class="question-image" @click="previewImage(formData.second.result_img, index)" v-for="(item, index) in formData.second.result_img"><img
                    :src="item"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card question-card" v-if="formData.third">
        <div class="question-header">妇科</div>
        <div class="card-content">
          <div class="baseinfo-item" v-if="formData.third.menarche">
            <div class="type">初潮年龄 (岁)</div>
            <div class="content">{{formData.third.menarche}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.third.cycle">
            <div class="type">月经周期 (天)</div>
            <div class="content">{{formData.third.cycle}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.third.days">
            <div class="type">行经期天数 (天)</div>
            <div class="content">{{formData.third.days}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.third.lastMenstruation">
            <div class="type">末次月经时间</div>
            <div class="content">{{formData.third.lastMenstruation | parseDateToDay}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.third.amenorrhea">
            <div class="type">是否闭经</div>
            <div class="content">{{formData.third.amenorrhea}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.third.amenorrheaAge">
            <div class="type">闭经年龄 (岁)</div>
            <div class="content">{{formData.third.amenorrheaAge}}</div>
          </div>
        </div>
        <div class="question-list west">
          <div class="qa-item" v-for="(item, index) in formData.third.questions[0].questionList">
            <div class="question">{{index + 1}}. {{item.question}}</div>
            <div class="answer" v-if="item.questionType == 'text'">{{item.text}}</div>
            <div class="answer" v-else-if="item.questionType == 'radio'">{{item.picked[0]}}</div>
            <div class="answer" v-else-if="item.questionType == 'mulitple'">{{item.picked.join('；')}}</div>
          </div>
        </div>
      </div>
    </template>
    <!-- 图片预览 -->
    <van-image-preview v-model="previewShow" :images="previewList" :start-position="imageIndex"></van-image-preview>
  </div>
</template>

<style lang="less" scoped>
  .question-paper{
    padding-top: 12px;
    .card{
      border-radius: 6px;
      background: #FFF;
      overflow: hidden;
      &:not(:first-child){
        margin-top: 12px;
      }
      &.question-card{
        padding: 0 20px;
        .card-content{
          padding: 20px 0 0;
          border-bottom: 1px solid #EEE;
          .baseinfo-item:last-child{
            margin-bottom: 20px;
          }
        }
      }
      .card-header{
        padding: 20px 12px 16px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #FAFAFA;
        border-bottom: 1px solid #F3F3F3;
        h3{
          font-size: 20px;
          line-height: 20px;
          color: @black;
          font-weight: bold;
        }
        .date{
          font-size: 14px;
          line-height: 14px;
          color: #666;
        }
      }
      .card-content{
        padding: 20px 16px 0;
        .baseinfo-item{
          margin-bottom: 32px;
          .type{
            font-size: 15px;
            line-height: 15px;
            color: #666;
          }
          .content{
            margin-top: 8px;
            font-size: 15px;
            line-height: 20px;
            color: @black;
            font-weight: bold;
            .patient-info{
              vertical-align: middle;
              span{
                font-size: 12px;
                color: #CCC;
                margin: 0 12px;
                font-weight: normal;
              }
            }
          }
        }
        .question-image-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          .question-image{
            width: 96px;
            height: 96px;
            overflow: hidden;
            border-radius: 4px;
            margin-top:6px;
            margin-right: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #000;
            img{
              width: 100%;
            }
          }
        }
      }
      .question-header{
        height: 48px;
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: @wenzhen;
        border-bottom: 1px solid #EEE;
      }
      .question-list{
        margin-top: 16px;
        padding-bottom: 10px;
        &.west{
          margin-top: 20px;
        }
        .qa-item{
          color: @black;
          margin-bottom: 30px;
          .question{
            font-size: 16px;
            line-height: 16px;
          }
          .answer{
            margin-top: 20px;
            font-size: 15px;
            line-height: 15px;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      formData: {
        type: Object,
        default: {
          create_time: 0,
          pat_username: '未知患者名',
        }
      }
    },
    data() {
      return {
        previewShow: false,
        previewList: [],
        imageIndex: 0,
      }
    },
    methods: {
      previewImage(image, index) {
        this.previewList = image;
        this.imageIndex = index;
        this.previewShow = true;
      }
    },
    filters: {
      dateFilter(stamp) {
        return moment.unix(stamp).format('YYYY.MM.DD HH:mm');
      },
      timeFilter(stamp) {
        return moment.unix(stamp).format('HH:mm');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/questionnaire.vue